import {IUserProfile} from '@/interfaces/user';
import {AdminState} from './state';
import {getStoreAccessors} from 'typesafe-vuex';
import {State} from '../state';
import {IForm, IFormCategory} from '@/interfaces/form';
import {IRole, IRoleSettings} from '@/interfaces/role';
import {IExternalData} from '@/interfaces/external-data';
import {ISearchEngine} from '@/interfaces/search_engine';
import {IExternalUser} from '@/interfaces/external_user';
import {IGroup} from "@/interfaces/group";
import {IInstitution} from "@/interfaces/institution";
import {IAddress} from "@/interfaces/address";

export const mutations = {
    setUsers(state: AdminState, payload: IUserProfile[]) {
        state.users = payload;
    },
    setUser(state: AdminState, payload: IUserProfile) {
        const filtered = state.users.filter((item: IUserProfile) => item.id !== payload.id);
        filtered.push(payload);
        state.users = filtered;
    },
    setForms(state: AdminState, payload: IForm[]) {
      state.forms = payload;
    },
    setForm(state: AdminState, payload: IForm) {
        const filtered = state.forms.filter((item: IForm) => item.id !== payload.id);
        filtered.push(payload);
        state.forms = filtered;
    },
    setRoles(state: AdminState, payload: IRole[]) {
        state.roles = payload;
    },
    setRole(state: AdminState, payload: IRole) {
        const filtered = state.roles.filter((item: IRole) => item.id !== payload.id);
        filtered.push(payload);
        state.roles = filtered;
    },
    setDefaultRoleSettings(state: AdminState, payload: IRoleSettings) {
        state.role_settings = payload;
    },

    setExternalData(state: AdminState, payload: IExternalData) {
        const filtered = state.external_data_list.filter((item: IExternalData) => item.id !== payload.id);
        filtered.push(payload);
        state.external_data_list = filtered;
    },
    setExternalDataList(state: AdminState, payload: IExternalData[]) {
        state.external_data_list = payload;
    },

    setAdminSearchEngine(state: AdminState, payload: ISearchEngine) {
        const filtered = state.search_engines.filter((item: ISearchEngine) => item.id !== payload.id);
        filtered.push(payload);
        state.search_engines = filtered;
    },
    setAdminSearchEngines(state: AdminState, payload: ISearchEngine[]) {
        state.search_engines = payload;
    },
    setExternalUser(state: AdminState, payload: IExternalUser) {
        const filtered = state.external_users.filter((item: IExternalUser) => item.id !== payload.id);
        filtered.push(payload);
        state.external_users = filtered;
    },
    setExternalUsers(state: AdminState, payload: IExternalUser[]) {
        state.external_users = payload;
    },
    setGroup(state: AdminState, payload: IGroup) {
        const filtered = state.groups.filter((item: IGroup) => item.id !== payload.id);
        filtered.push(payload);
        state.groups = filtered;
    },
    setFormCategories(state: AdminState, payload: IFormCategory[]) {
        state.form_categories = payload;
    },
    setFormCategory(state: AdminState, payload: IFormCategory) {
        const filtered = state.form_categories.filter((item: IFormCategory) => item.id !== payload.id);
        filtered.push(payload);
        state.form_categories = filtered;
    },
    setGroups(state: AdminState, payload: IGroup[]) {
        state.groups = payload;
    },

    setInstitution(state: AdminState, payload: IInstitution) {
        const filtered = state.institutions.filter((item: IInstitution) => item.id !== payload.id);
        filtered.push(payload);
        state.institutions = filtered;
    },
    setInstitutions(state: AdminState, payload: IInstitution[]) {
        state.institutions = payload;
    },

    // Public state
    setAddress(state: AdminState, payload: IAddress) {
        state.address = payload;
    },
};

const { commit } = getStoreAccessors<AdminState, State>('');

export const commitSetUser = commit(mutations.setUser);
export const commitSetUsers = commit(mutations.setUsers);

export const commitSetFormAdmin = commit(mutations.setForm);
export const commitSetFormsAdmin = commit(mutations.setForms);

export const commitSetRole = commit(mutations.setRole);
export const commitSetDefaultRoleSettings = commit(mutations.setDefaultRoleSettings);
export const commitSetRoles = commit(mutations.setRoles);

export const commitSetExternalData = commit(mutations.setExternalData);
export const commitSetExternalDataList = commit(mutations.setExternalDataList);

export const commitSetAdminSearchEngine = commit(mutations.setAdminSearchEngine);
export const commitSetAdminSearchEngines = commit(mutations.setAdminSearchEngines);

export const commitSetExternalUser = commit(mutations.setExternalUser);
export const commitSetExternalUsers = commit(mutations.setExternalUsers);

export const commitSetGroup = commit(mutations.setGroup);
export const commitSetGroups = commit(mutations.setGroups);

export const commitSetFormCategory = commit(mutations.setFormCategory);
export const commitSetFormCategories = commit(mutations.setFormCategories);

export const commitSetInstitution = commit(mutations.setInstitution);
export const commitSetInstitutions = commit(mutations.setInstitutions);

// Public
export const commitSetAddress = commit(mutations.setAddress);
